import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { PrimaryButton, SecondaryButton, useDialog } from 'ogp/providers/dialog-provider';
import { IconApproved, IconCancel } from 'assets/img';
import { accreditationsAlerts, useAlert } from 'shared/components/alerts';
import { useApproveAccreditation } from '../../hooks/use-approve-accreditation';
import {
  AccreditationDetailFormValues,
  ApproveAccreditationButtonProps,
} from '../accreditations-detail.types';

export const useAccreditationDetailApproveAction = ({
  flexWorkerId,
  certificateId,
  expirationDate,
  accreditationType,
  closeModal,
}: ApproveAccreditationButtonProps) => {
  const { openDialog, closeDialog, enableDialog, disableDialog } = useDialog();
  const { alertSuccess, alertError } = useAlert();
  const mutation = useApproveAccreditation();
  const { setValue } = useFormContext<AccreditationDetailFormValues>();

  const mutationData = useMemo(
    () => ({
      flexWorkerId,
      certificateId,
      accreditationType,
      ...(expirationDate && { expirationDate }),
    }),
    [certificateId, flexWorkerId, expirationDate, accreditationType]
  );

  const handleApproveAccreditation = () => {
    openDialog(
      {
        title: 'Weet u zeker dat u het certificaat goedkeurt?',
        secondaryButton: (props) => (
          <SecondaryButton iconColorMode="fill" startIcon={<IconCancel />} {...props}>
            Annuleer
          </SecondaryButton>
        ),
        primaryButton: (props) => (
          <PrimaryButton startIcon={<IconApproved />} {...props}>
            Bevestig
          </PrimaryButton>
        ),
      },
      () => {
        disableDialog();
        mutation.mutate(mutationData, {
          onSuccess: () => {
            setValue('rejectionReason', '');
            closeDialog();
            closeModal();
            alertSuccess(accreditationsAlerts.success.approved);
          },
          onError: (e) => alertError(e),
          onSettled: () => {
            enableDialog();
          },
        });
      }
    );
  };

  return { handleApproveAccreditation };
};
